export class PaymentAuthorizationRequest {
  paymentAdviceNumber?: string;
  settlementCurrency?: string;
  settlementAmount?: number;
  awb?: string;
  airport?: string;
  paymentMode?: string;
  authorizationCode?: string;
  source?: string;
  signature1?: string;
  signature2?: string;
  isTransactionComplete?: boolean;

  constructor(
    paymentAdviceNumber?: string,
    settlementCurrency?: string,
    settlementAmount?: number,
    awb?: string,
    airport?: string,
    paymentMode?: string,
    authorizationCode?: string,
    source?: string,
    signature1?: string,
    signature2?: string,
    isTransactionComplete?: boolean
  ) {
    this.paymentAdviceNumber = paymentAdviceNumber;
    this.settlementCurrency = settlementCurrency;
    this.settlementAmount = settlementAmount;
    this.awb = awb;
    this.airport = airport;
    this.paymentMode = paymentMode;
    this.authorizationCode = authorizationCode;
    this.source = source;
    this.signature1 = signature1;
    this.signature2 = signature2;
    this.isTransactionComplete = isTransactionComplete;
  }
}
